<template>
  <v-container id="city-get">
    <v-breadcrumbs
      v-if="isSala"
      :items="breadCrumbs"
      divider=">"
    ></v-breadcrumbs>

    <city-header :payload="payload" v-if="isAuthenticated" @realod="loadFirst">
    </city-header>

    <v-row class="aqui">
      <v-col
        v-if="
          isSala &&
          ((config.verDashboardEvidencia &&
            groupsConfig.verDashboardEvidencia) ||
            (config.verStatusDiagnosticoSelo &&
              groupsConfig.verStatusDiagnosticoSelo))
        "
        class="diagnosticoSelo"
        :cols="
          isFullAdmin ||
          (config.visualizaRelatorioFinal &&
            groupsConfig.visualizaRelatorioFinal) ||
          (config.realizarDiagnostico && groupsConfig.realizarDiagnostico) ||
          (config.editarMunicipio && groupsConfig.editarMunicipio) ||
          (config.relatorioMensal && groupsConfig.relatorioMensal) ||
          (config.verEvolucaoMunicipio && groupsConfig.verEvolucaoMunicipio)
            ? '9'
            : '12'
        "
      >
        <v-col
          v-if="
            config.verDashboardEvidencia && groupsConfig.verDashboardEvidencia
          "
        >
          <h3 class="mb-5 mt-5">Situação dos critérios</h3>

          <mini-dash :municipioId="parseInt(this.$route.params.id)"></mini-dash>
        </v-col>
        <template
          v-if="
            config.verStatusDiagnosticoSelo &&
            groupsConfig.verStatusDiagnosticoSelo
          "
        >
          <div class="titulo">STATUS DA FASE DIAGNÓSTICO</div>
          <div class="tituloStatus">{{ situacaoMunicipio }}</div>
          <div>
            <v-row
              v-if="
                isSala &&
                (isFullAdmin ||
                  (config.diagnosticoSelo && groupsConfig.diagnosticoSelo))
              "
            >
              <v-col>
                <v-btn
                  color="azulclarosc"
                  class="ml-3"
                  style="color: #fff"
                  @click="openDiagnosticoSelo"
                >
                  <template>
                    {{
                      situacaoMunicipio == "Diagnóstico Não iniciado"
                        ? "Iniciar"
                        : situacaoMunicipio == "Diagnóstico em preenchimento"
                        ? "Continuar"
                        : "Visualizar"
                    }}
                    DIAGNÓSTICO
                  </template>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>
        <v-row>
          <v-col>
            <v-btn
              v-if="
                situacaoMunicipio == 'Diagnóstico Enviado' &&
                (isFullAdmin ||
                  (config.downloadDiagnostico &&
                    groupsConfig.downloadDiagnostico))
              "
              color="laranja"
              class="ml-3"
              @click="downloadPdf"
              style="color: #fff"
            >
              Download Diagnóstico
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        md="9"
        sm="9"
        lg="9"
        v-if="
          !isSala ||
          (isSala &&
            !config.verStatusDiagnosticoSelo &&
            !groupsConfig.verStatusDiagnosticoSelo &&
            !config.verDashboardEvidencia &&
            !groupsConfig.verDashboardEvidencia)
        "
      >
        <v-card>
          <v-card-text v-if="!isAT">
            <template
              v-if="
                isFullAdmin ||
                (config.visualizarPontosMedalha &&
                  groupsConfig.visualizarPontosMedalha &&
                  getMunicipioVigente()) ||
                (config.verEvolucaoMunicipio &&
                  groupsConfig.verEvolucaoMunicipio)
              "
            >
              <h4>{{ isSala ? "EVOLUÇÃO" : "EVOLUÇÃO DO MUNICÍPIO" }}</h4>
              <v-divider> </v-divider>
            </template>

            <v-row
              v-if="
                isFullAdmin ||
                (config.visualizarPontosMedalha &&
                  groupsConfig.visualizarPontosMedalha &&
                  getMunicipioVigente())
              "
            >
              <v-col cols="1">
                <v-icon color="primary"> mdi-chart-bar </v-icon>
              </v-col>

              <v-col cols="2" class="d-flex justify-content-center">
                <v-row align="center">
                  <span> Pontos Totais: {{ payload.pontos }} </span>
                </v-row>
              </v-col>

              <v-col sm="1">
                <v-icon color="primary"> mdi-medal </v-icon>
              </v-col>

              <v-col sm="2" class="d-flex justify-content-center">
                <v-row align="center">
                  <span> Medalhas: {{ payload.totalMedalhas }} </span>
                </v-row>
              </v-col>
            </v-row>

            <v-row
              style="display: flex"
              v-if="
                isFullAdmin ||
                (config.visualizarPontosMedalha &&
                  groupsConfig.visualizarPontosMedalha &&
                  getMunicipioVigente()) ||
                (config.verEvolucaoMunicipio &&
                  groupsConfig.verEvolucaoMunicipio)
              "
            >
              <v-col
                md="5"
                sm="5"
                lg="5"
                offset="1"
                v-if="
                  isFullAdmin ||
                  (config.visualizarPontosMedalha &&
                    groupsConfig.visualizarPontosMedalha &&
                    getMunicipioVigente())
                "
              >
                <line-chart
                  :chart-data="lineChart"
                  :options="lineChartOptions"
                  :width="200"
                  :height="200"
                ></line-chart>
              </v-col>

              <v-col
                v-if="
                  isFullAdmin ||
                  (config.verEvolucaoMunicipio &&
                    groupsConfig.verEvolucaoMunicipio)
                "
              >
                <bar-chart
                  :chart-data="barChart"
                  :options="barChartOptions"
                  :width="200"
                  :height="200"
                ></bar-chart>
              </v-col>
            </v-row>
            <v-row
              align="center"
              justify="center"
              v-if="
                isFullAdmin ||
                (config.visualizarPontosMedalha &&
                  groupsConfig.visualizarPontosMedalha &&
                  getMunicipioVigente())
              "
            >
              <v-col
                v-for="medalha in payload.medalhas"
                v-bind:key="medalha.municipioMedalhaId"
                cols="2"
              >
                <div
                  v-if="
                    medalha.medalha.imagemBronzeBlobS3Url ||
                    medalha.medalha.imagemBronzeBlob ||
                    medalha.medalha.imagemBronze
                  "
                >
                  <img
                    :src="
                      medalha.medalha.imagemBronzeBlobS3Url
                        ? medalha.medalha.imagemBronzeBlobS3Url
                        : medalha.medalha.imagemBronzeBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemBronzeBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemBronze
                    "
                    v-if="medalha.possui === false && showMedalGrey === true"
                    :width="medalWidth"
                    class="grayScale"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemOuroBlobS3Url
                        ? medalha.medalha.imagemOuroBlobS3Url
                        : medalha.medalha.imagemOuroBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemOuroBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemOuro
                    "
                    v-if="medalha.possuiOuro"
                    :width="medalWidth"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemPrataBlobS3Url
                        ? medalha.medalha.imagemPrataBlobS3Url
                        : medalha.medalha.imagemPrataBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemPrataBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemPrata
                    "
                    v-if="!medalha.possuiOuro && medalha.possuiPrata"
                    :width="medalWidth"
                  />

                  <img
                    :src="
                      medalha.medalha.imagemBronzeBlobS3Url
                        ? medalha.medalha.imagemBronzeBlobS3Url
                        : medalha.medalha.imagemBronzeBlob
                        ? 'data:image/jpeg;base64,' +
                          medalha.medalha.imagemBronzeBlob
                        : '/assets/img/medalhas/' + medalha.medalha.imagemBronze
                    "
                    v-if="!medalha.possuiPrata && medalha.possuiBronze"
                    v-bind:class="{ medalhas: !medalha.possui }"
                    :width="medalWidth"
                  />
                </div>
              </v-col>
            </v-row>

            <div v-if="estado === 'RJ1'">
              <h4>RELATÓRIO DO GESTOR</h4>
              <v-divider> </v-divider>

              <v-textarea
                v-model="payload.relatorioGestor"
                :disabled="!editReport"
                :readonly="!editReport"
              >
              </v-textarea>
              <v-divider> </v-divider>

              <v-col class="text-right">
                <v-btn
                  outlined
                  color="primary"
                  class="ml-3"
                  v-if="editReport === true"
                  @click="updateReport()"
                >
                  SALVAR
                </v-btn>

                <v-btn
                  v-if="
                    isAdmin ||
                    isConsultorCondutorMunicipio ||
                    isADMunicipio ||
                    isConsultorEspecialistaMunicipio
                  "
                  outlined
                  color="primary"
                  class="ml-3"
                  @click="editReport = !editReport"
                >
                  <span v-if="editReport === false"> EDITAR </span>
                  <span v-if="editReport === true"> CANCELAR </span>
                </v-btn>
              </v-col>
            </div>
          </v-card-text>
          <v-card-text v-if="isAT">
            <h4>SOBRE O MUNICÍPIO</h4>
            <v-divider> </v-divider>

            <v-row class="mt-4" style="min-height: 30vh">
              <v-col>
                {{ payload.descricao }}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row v-if="payload.prefeito">
              <v-col md="12" sm="12" lg="12">
                <h4 v-if="isSala">SOBRE O PARCEIRO</h4>

                <h4 v-else>SOBRE O MUNICÍPIO</h4>
                <v-divider></v-divider>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.populacao">
                <h4>População</h4>
                <v-divider></v-divider>
                <span>{{ payload.populacao }} Hab.</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.orcamento">
                <h4>Orçamento</h4>
                <v-divider></v-divider>
                <span>R$ {{ payload.orcamento }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.isdel">
                <h4>ISDEL</h4>
                <v-divider></v-divider>
                <span>{{ payload.isdel }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.idh">
                <h4>IDH</h4>
                <v-divider></v-divider>
                <span>{{ payload.idh }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.pib">
                <h4>PIB</h4>
                <v-divider></v-divider>
                <span>{{ payload.pib }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.densidadeDemografica">
                <h4>Densidade Demográfica</h4>
                <v-divider></v-divider>
                <span>{{ payload.densidadeDemografica }} Hab/Km²</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.rendaMedia">
                <h4>Renda Média</h4>
                <v-divider></v-divider>
                <span>R$ {{ payload.rendaMedia }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.receita">
                <h4>Receita</h4>
                <v-divider></v-divider>
                <span>R$ {{ payload.receita }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.area">
                <h4>Área KM²</h4>
                <v-divider></v-divider>
                <span>{{ payload.area }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.despesa">
                <h4>Despesa</h4>
                <v-divider></v-divider>
                <span>R$ {{ payload.despesa }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.tempoMedio">
                <h4>Tempo Médio Abertura de Empresas</h4>
                <v-divider></v-divider>
                <span>{{ payload.tempoMedio }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.numeroEmpresas">
                <h4>Empresas</h4>
                <v-divider></v-divider>
                <span>{{ payload.numeroEmpresas }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.me">
                <h4>ME e EPP</h4>
                <v-divider></v-divider>
                <span>{{ payload.me }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.mei">
                <h4>MEI</h4>
                <v-divider></v-divider>
                <span>{{ payload.mei }}</span>
              </v-col>
              <v-col md="4" sm="4" lg="4" v-if="payload.totalMEI">
                <h4>MEI / Total</h4>
                <v-divider></v-divider>
                <span>{{ payload.totalMEI }} %</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.ideb">
                <h4>IDEB</h4>
                <v-divider></v-divider>
                <span>{{ payload.ideb }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.docentesEF">
                <h4>Nº Docentes Educação Infantil</h4>
                <v-divider></v-divider>
                <span>{{ payload.docentesEF }}</span>
              </v-col>

              <v-col md="4" sm="4" lg="4" v-if="payload.alunosEF">
                <h4>Nº Alunos Educação Infantil</h4>
                <v-divider></v-divider>
                <span>{{ payload.alunosEF }}</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col md="4" sm="4" lg="4" v-if="payload.igm">
                <h4>IGM</h4>
                <v-divider></v-divider>
                <span>{{ payload.igm }} %</span>
              </v-col>
            </v-row>

            <v-row v-if="payload.atividades && payload.atividades.length > 0">
              <v-col md="12" sm="12" lg="12">
                <h3>Atividades Econômicas</h3>
                <v-divider></v-divider>
                <v-row
                  v-for="atividade in payload.atividades"
                  v-bind:key="atividade.municipioAtividadeId"
                  align="center"
                >
                  <v-col md="3" sm="3" lg="3">
                    <v-avatar color="primary">
                      <v-icon color="white">
                        {{ atividade.atividade.icone }}
                      </v-icon>
                    </v-avatar>
                  </v-col>

                  <v-col>
                    {{ atividade.atividade.nome }}
                  </v-col>
                  <v-col> Participação: {{ atividade.percentual }} % </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        md="3"
        sm="3"
        lg="3"
        v-if="
          isFullAdmin ||
          !config.diagnosticoSelo ||
          !groupsConfig.diagnosticoSelo
        "
      >
        <v-row
          v-if="
            isSala &&
            (isFullAdmin ||
              (config.visualizaRelatorioFinal &&
                groupsConfig.visualizaRelatorioFinal))
          "
        >
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="verificarRelatorioFinal()"
            >
              Relatório Final
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              v-if="
                payload.diagnostico === false &&
                (isFullAdmin ||
                  (config.realizarDiagnostico &&
                    groupsConfig.realizarDiagnostico))
              "
              @click="openDiagnostic()"
            >
              <template v-if="isSala">
                RESPONDER CRITÉRIOS <br />
                DE AVALIAÇÃO
              </template>
              <template v-else> RESPONDER DIAGNÓSTICO </template>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-modal-edit-city
              v-if="
                isFullAdmin ||
                (config.editarMunicipio && groupsConfig.editarMunicipio)
              "
              @save="loadCity()"
              :payload="payload"
              :edit="true"
            ></app-modal-edit-city>
          </v-col>
        </v-row>
        <v-row
          v-if="
            isFullAdmin ||
            (config.resumoMunicipio && groupsConfig.resumoMunicipio)
          "
        >
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="$router.push(`/cidade/${municipioId}/resumo-municipio`)"
            >
              <template v-if="isSala">RESUMO DO PARCEIRO</template>
              <template v-else-if="isTur"> RESUMO DO MUNICÍPIO</template>

              <template v-else> ATORES DO MUNICÍPIO</template>
            </v-btn>
          </v-col>
        </v-row>
        <v-row
          v-if="
            config.relatorioMensal &&
            groupsConfig.relatorioMensal &&
            !isIndicadores &&
            !isSala
          "
        >
          <v-col>
            <app-modal-report :municipioId="municipioId"> </app-modal-report>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="
                $router.push(`/cidade/${municipioId}/agenteTerritorial/ator`)
              "
              v-if="
                isAT &&
                (isFullAdmin ||
                  (config.agenteTerritorial && groupsConfig.agenteTerritorial))
              "
            >
              AGENTE TERRITORIAL
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="payload.linkMaps">
          <v-col>
            <v-btn outlined color="primary" class="ml-3" @click="openMaps()">
              ABRIR MAPS
            </v-btn>
          </v-col>
        </v-row>
        <v-card
          v-if="
            perfis.filter((item) => item.children && item.children.length)
              .length > 0 ||
            payload.prefeito ||
            payload.partido
          "
        >
          <v-card-text>
            <v-row>
              <v-col v-if="payload.prefeito">
                <h4>Prefeito</h4>
                <v-divider></v-divider>
                <span>{{ payload.prefeito }}</span>
              </v-col>
              <v-col v-if="payload.partido" lg="4" md="4" sm="4">
                <h4>Partido</h4>
                <v-divider></v-divider>
                <span>{{ payload.partido }}</span>
              </v-col>
            </v-row>

            <v-row
              v-if="
                perfis.filter((item) => item.children && item.children.length)
                  .length > 0
              "
            >
              <v-col
                v-for="perfil in perfis"
                :key="perfil.idMunicipioResumoPerfil"
                lg="12"
                md="12"
                sm="12"
              >
                <h4>{{ perfil.nome }}</h4>

                <div
                  v-for="children in perfil.children"
                  :key="children.resumoId"
                >
                  <div>{{ children.nome }}</div>

                  <div>{{ children.telefone }}</div>

                  <div>{{ children.email }}</div>
                </div>
                <div v-if="!perfil.children.length">Não possui</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <modal-link-oculto-relatorio-final
        :municipio="payload"
        :dialog="abrirModalRelFinal"
        @relFimCriado="gerarRelatorioFinal()"
        @atualizarRelatorio="loadCity()"
      ></modal-link-oculto-relatorio-final>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import AppModalEditCity from "./ModalEdit";
import LineChart from "@/components/chart/LineChart";
import BarChart from "@/components/chart/BarChart";
import CityHeader from "./Header";
import { cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppModalReport from "@/modules/report/components/ModalReport";
import AgenteTerritorial from "@/modules/agenteTerritorial/list";
import { resumoMunicipioApi, resumoMunicipioPerfilApi } from "@/apis";
import {
  statusRelacionamentoEnum,
  statusRelacionamentoSeloEnum,
  statusContratoEnum,
} from "@/types";
import { diagnosticAPI } from "@/modules/diagnostic/components/DiagnosticAPI.js";
import { reportAPI } from "@/modules/report/API/ReportAPI";
import ModalLinkOcultoRelatorioFinal from "./ModalLinkOcultoRelatorioFinal.vue";
import Swal from "sweetalert2";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import { seloDiagnosticoPerguntasAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoPerguntasAPI";
import MiniDash from "./MiniDash.vue";
export default {
  components: {
    AppModalEditCity,
    LineChart,
    BarChart,
    CityHeader,
    AppModalReport,
    AgenteTerritorial,
    ModalLinkOcultoRelatorioFinal,
    MiniDash,
  },
  data() {
    return {
      acompanhamento: {
        nome: "Diagnóstico",
        municipioId: parseInt(this.$route.params.id),
        usuarioId: 1,
      },
      breadCrumbs: [
        {
          text: "Selecionar a Sala",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Preencher Diagnóstico",
          disabled: true,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
      ],
      abrirModalRelFinal: false,
      municipioId: this.$route.params.id,
      medalWidth: "135px",
      config: JSON.parse(localStorage.getItem("config")),
      userTeste: JSON.parse(localStorage.getItem("user")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      showMedalGrey: false,
      payload: {
        acompanhamentos: [],
        temas: [],
      },
      statusRelacionamentoEnum: statusRelacionamentoEnum,
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      statusContratoEnum: statusContratoEnum,
      editReport: false,
      nomesAcompanhamentos: [],
      pontosAcompanhamentos: [],
      nomesTemas: [],
      percentuaisTemas: [],
      lineChart: {},
      lineChartOptions: {
        // onHover: (e) => {
        //   if (e.type == 'mousemove') {
        //     this.lineChartOptions.scales.xAxes[0].ticks.display = true
        //   } else if (e.type == 'mouseout') {
        //     this.lineChartOptions.scales.xAxes[0].ticks.display = false
        //   }
        // },

        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
                max: 100,
                display: false,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },

        responsive: true,
        maintainAspectRatio: false,
      },
      barChart: {},
      barChartOptions: {
        scales: {
          yAxes: [
            {
              gridLines: {
                display: true,
              },
              ticks: {
                callback: function (label) {
                  if (label == null) {
                    return "";
                  }
                  if (label.length > 15) {
                    label = label.substring(0, 15);
                    label += "...";
                  }
                  return label;
                },
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMin: 0,
                max: 100,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      perfis: [],
      estado: this.$store.state.uf,
      situacaoMunicipio: null,
    };
  },

  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
      "setCityName",
      "setCityId",
    ]),
    openDiagnosticoSelo() {
      if (this.situacaoMunicipio == "Diagnóstico Não iniciado") {
        this.modalDiagnosticoSelo();
      } else {
        this.$router.push("/cidade/" + this.municipioId + "/diagnostic/selo");
      }
    },
    modalDiagnosticoSelo() {
      Swal.fire({
        title:
          "O Sebrae agradece desde já a sua participação no Selo Sebrae de Referência em Atendimento!",
        html: `
        <div class='estruturas'>
<p style="font-size:20px; margin-bottom:1rem">O preenchimento do formulário de levantamento de informações é uma etapa obrigatória e tem por objetivos:
</p>
<p><strong>•</strong> Conhecer as estruturas atuais e serviços ofertados pelas instituições parceiras;</p>
<p><strong>•</strong> Acompanhar a evolução desses espaços antes e após a aplicação da metodologia do Selo Sebrae de Referência em Atendimento;</p>
<p><strong>•</strong> Receber informações sobre as instituições parceiras para avaliação de critérios descritos no Regulamento.</p>
</div>
<p  style="font-size:18px; margin:1rem 0">A aplicação do questionário do diagnóstico é realizada no formato “autopreenchimento”, ou seja, os responsáveis pelas instituições parceiras participantes receberão o formulário de forma digital (por meio do e-mail informado no formulário de inscrição) e deverão respondê-lo dentro do cronograma oficial do Selo (divulgado no site oficial do Selo).</p>
<div class='estruturas'>
<p style="font-size:20px; margin-bottom:1rem">As perguntas serão relacionadas aos seguintes aspectos:</p>
<p><strong>•</strong> Serviços ofertados;</p>
<p><strong>•</strong> Infraestrutura (física e digital); </p>
<p><strong>•</strong> Canais de Atendimento; </p>
<p><strong>•</strong> Equipes de atendimento; </p>
<p><strong>•</strong> Parceiros.</p>
</div>
<div class='atencao'>
<p style="font-size:30px; font-weight:bold">Leia com atenção!</p>
<p style="font-size:20px; margin:1.5rem 0">O formulário deverá ser preenchido até dia <strong>26/04/2024</strong> até as <strong>23:59h</strong>.</p>
</div>
<p style="font-size:20px; margin-bottom:1rem">O responsável pelo preenchimento do diagnóstico deverá:</p>
<div class='estruturas'>
<p><strong>•</strong> Preencher corretamente as informações solicitadas;</p>
<p><strong>•</strong> Responder a todas as perguntas com atenção e dentro do prazo estipulado pelo Sebrae;</p>
<p><strong>•</strong> Preencher somente <strong>UM formulário</strong>. Não deverão ser preenchidos mais de um formulário de diagnóstico por ${
          this.isParceiro ? "parceiro" : "sala"
        }.</p>
<p><strong>•</strong> Reserve um tempo destinado somente ao preenchimento do diagnóstico.</p>
<p><strong>•</strong> No Bloco de perguntas do diagnóstico nomeado como informações para o Cliente Oculto serão coletadas
  informações sobre ${
    this.isParceiro ? "os parceiros" : "as salas"
  } que serão utilizadas para realização do Cliente Oculto.</p>

<p><strong>•</strong> É necessário a leitura dos critérios relacionados ao Cliente Oculta que conta Critério de Avaliação  - Pilar Qualidade no atendimento remoto 8.1.1.2 CLIENTE OCULTO - ATENDIMENTO REMOTO</p>
<p><strong>•</strong> O preenchimento deverá ser realizado corretamente, pois não haverá substituição de informações após o encerramento do prazo para preenchimento do diagnóstico.</p>

<p style='text-align:center'> <a target="_blank" href="https://sebrae.com.br/Sebrae/Portal%20Sebrae/Selo%20de%20Refer%C3%AAncia/Regulamento%20Selo%20-%20Salas%20do%20Empreendedor%20-%202024_VF2.pdf">Leia o regulamento do selo sebrae de referência em atendimento </a></p>

</div>
        `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "voltar",
        confirmButtonText: "ESTOU CIENTE E DE ACORDO",
        reverseButtons: true,
        width: "90%",
        customClass: {
          htmlContainer: "htmlContainer",
          popup: "tamanho",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push("/cidade/" + this.municipioId + "/diagnostic/selo");
        }
      });
    },
    verificarRelatorioFinal() {
      if (
        this.isFullAdmin ||
        (this.config.podeTrocarLinkRelFim &&
          this.groupsConfig.podeTrocarLinkRelFim)
      ) {
        this.abrirModalRelFinal = true;
      } else {
        this.gerarRelatorioFinal();
      }
    },
    getMunicipioVigente() {
      let isVigente = true;

      if (this.$store.state.uf === "RJ" && !this.isSala && !this.isAT) {
        isVigente =
          this.statusContratoEnum.cidadeEmpreendedora ===
            this.payload.statusContratoId &&
          this.payload.statusId === this.statusRelacionamentoEnum.vigente;
      } else {
        isVigente =
          (this.isSala &&
            this.payload.statusId ===
              this.statusRelacionamentoSeloEnum.participante) ||
          this.payload.statusId === this.statusRelacionamentoEnum.vigente;
      }

      return isVigente;
    },
    downloadPdf() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .downloadPdf(this.municipioId)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Diagnostico - ${this.payload.nome} - ${
            this.payload.uf
          } - ${moment().format("DD_MM_YYYY_HH_mm")}.pdf`;
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF de perguntas");
        });
    },

    loadCity() {
      this.abrirModalRelFinal = false;
      this.setLoading(true);

      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.payload = resp.data;
          this.setCityName(this.payload.nome);
          this.setCityId(this.payload.municipioId);

          this.nomesAcompanhamentos = this.payload.acompanhamentos.map(
            function (item) {
              return item.nome;
            }
          );

          this.pontosAcompanhamentos = this.payload.acompanhamentos.map(
            function (item) {
              return item.pontos;
            }
          );

          for (
            let count = 0;
            count < this.pontosAcompanhamentos.length;
            count++
          ) {
            if (count > 0)
              this.pontosAcompanhamentos[count] =
                this.pontosAcompanhamentos[count] +
                this.pontosAcompanhamentos[count - 1];
          }

          var temasPermissoes = this.payload.temas;

          if (!this.userTeste.grupo.verTodosEixos) {
            temasPermissoes = temasPermissoes.filter((item) =>
              this.userTeste.permissoes.some(
                (per) =>
                  per.eixoId === item.tema.eixoId &&
                  per.municipioId === item.municipioId
              )
            );

            this.payload.medalhas = this.payload.medalhas.filter((item) =>
              this.userTeste.permissoes.some(
                (per) =>
                  per.eixoId === item.medalha.temaId &&
                  per.municipioId === item.municipioId
              )
            );
          }

          this.nomesTemas = temasPermissoes.map(function (item) {
            return item.tema.nome;
          });

          this.percentuaisTemas = temasPermissoes.map(function (item) {
            return Math.ceil((item.pontos / item.tema.pontos) * 100);
          });

          this.fillLineChart();
          this.fillBarChart();
          this.setLoading(false);
          // setTimeout(() => {
          //   this.setLoading(false);
          // }, 1000);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    async getResumoMunicipioPerfil() {
      try {
        const { data: resumiMunicipioPerfil } =
          await resumoMunicipioPerfilApi.list();
        this.perfis = resumiMunicipioPerfil;
      } catch (error) {
        this.$notification.error("Erro ao listar perfis do municipio");
      }
    },
    gerarRelatorioFinal() {
      this.abrirModalRelFinal = false;
      this.setLoading(true);
      reportAPI
        .downloadRelatorioFinal(this.municipioId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Relatorio Final - 2023 - ${this.payload.nome}.pdf`;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatorio final");
        });
    },
    updateReport() {
      this.setLoading(true);
      cityAPI
        .update(this.payload)
        .then((resp) => {
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar relatório");
        });
    },
    openDiagnostic() {
      this.setLoading(true);
      diagnosticAPI
        .createDiagnostic(this.acompanhamento)
        .then((resp) => {
          this.setLoading(false);
          this.$router.push(
            "/diagnostico/" + this.acompanhamento.municipioId + "/tema"
          );
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao criar diagnóstico");
        });
    },
    fillLineChart() {
      this.lineChart = {
        labels: this.nomesAcompanhamentos,
        datasets: [
          {
            backgroundColor: "#5C8AB9",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.pontosAcompanhamentos,
          },
        ],
      };
    },
    fillBarChart() {
      this.barChart = {
        labels: this.nomesTemas,
        datasets: [
          {
            backgroundColor: "#5C8AB9",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "#249EBF",
            data: this.percentuaisTemas,
          },
        ],
      };
    },
    openMaps() {
      window.open(this.payload.linkMaps, "_blank");
    },
    loadFirst() {
      this.setLoading(true);
      if (this.isSala) {
        seloDiagnosticoPerguntasAPI
          .getSituacaoDiagnostico(this.$route.params.id)
          .then(({ data: situacao }) => {
            this.situacaoMunicipio = situacao[0].situacao;

            this.loadCity();
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter o status do municipio");
          });
      } else {
        this.loadCity();
      }
      this.setConsultorCondutorMunicipio(this.$route.params.id);
      this.setConsultorEspecialistaMunicipio(this.$route.params.id);
      this.setAnalistaMunicipio(this.$route.params.id);
      this.setADMunicipio(this.$route.params.id);

      if (this.$store.state.uf === "SC") {
        this.medalWidth = "135px";
      }

      if (this.$store.state.uf !== "SC") {
        this.showMedalGrey = true;
      }

      document.getElementsByClassName("v-content__wrap")[0].style.background =
        "none";
    },
    async loadResumoMunicipio() {
      try {
        const { data: resumoMunicipio } = await resumoMunicipioApi.list(
          this.municipioId
        );
        this.perfis = this.perfis.map((val) => ({
          ...val,
          children: resumoMunicipio.filter(
            (item) =>
              item.idMunicipioResumoPerfil == val.idMunicipioResumoPerfil
          ),
        }));
      } catch (error) {
        this.$notification.error("Erro ao listar perfis");
      }
    },
  },
  beforeMount() {
    if (this.isParceiro) {
      this.breadCrumbs = [
        {
          text: "Selecionar o Parceiro",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Preencher Diagnóstico",
          disabled: true,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
      ];
    }
  },
  mounted() {
    this.loadFirst();
    this.getResumoMunicipioPerfil();
    this.loadResumoMunicipio();
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isNA",
      "isIndicadores",
      "isAnalista",
      "isSala",
      "isFullAdmin",
      "isAT",
      "user",
      "isTur",
      "isParceiro",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.aqui {
  height: 69%;
}
.tituloStatus {
  font-size: 40px;
  font-weight: bold;
}
.diagnosticoSelo {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  /* padding: 3rem; */
  height: 100%;
  row-gap: 3rem;
}
</style>

<style lang="scss">
.container {
  height: 100%;
}
.htmlContainer {
  padding: 0 2rem !important;
  text-align: justify !important;
}
.estruturas {
  text-align: left !important;

  width: fit-content;
  row-gap: 10px;
  display: flex;
  flex-direction: column;
}

.tamanho {
  max-width: 1300px;
}

.atencao {
  text-align: center;
}
</style>
